import type { PlainService } from "@/queries/automations-queries";
import { ServicePhase } from "gitpod-next-api/gitpod/v1/environment_automation_pb";
import { type FC, useMemo } from "react";
import { type LabelPhase, PhaseLabel } from "@/components/environments/PhaseLabel";

export const EnvironmentServiceStatus: FC<{ service: PlainService }> = ({ service }) => {
    const phase: LabelPhase = useMemo((): LabelPhase => {
        const sameSession = service.status?.session === service.spec?.session;
        if (!sameSession) {
            // Optimistically update state to STARTING
            if (service.spec?.desiredPhase === ServicePhase.RUNNING) {
                return "starting";
            }
        }
        switch (service.status?.phase) {
            case ServicePhase.UNSPECIFIED:
                return "unspecified";
            case ServicePhase.STOPPED:
                return "stopped";
            case ServicePhase.DELETED:
                return "deleted";
            case ServicePhase.STOPPING:
                return "stopping";
            case ServicePhase.STARTING:
                return "starting";
            case ServicePhase.RUNNING:
                if (
                    service.spec?.desiredPhase === ServicePhase.STOPPED ||
                    service.spec?.desiredPhase === ServicePhase.DELETED
                ) {
                    // Optimistically update state to STOPPING.
                    return "stopping";
                }
                return "running";
            case ServicePhase.FAILED:
                return "failed";
            default:
                return "unspecified";
        }
    }, [service.spec?.desiredPhase, service.spec?.session, service.status?.phase, service.status?.session]);

    return <PhaseLabel phase={phase} />;
};
